import {
  Box,
  HStack,
  IconButton,
  Text,
  VStack,
  Link,
  Icon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { FaPhoneAlt, FaCalendarAlt } from "react-icons/fa";
import { keyframes } from "@emotion/react";
import { FaMapMarkerAlt } from "react-icons/fa";

const vibrateWithDelay = keyframes`
  0%, 50% { transform: translate(0, 0); }
  52.5% { transform: translate(-2px, 2px); }
  55% { transform: translate(2px, -2px); }
  57.5% { transform: translate(-2px, 2px); }
  60% { transform: translate(2px, -2px); }
  62.5% { transform: translate(-2px, 2px); }
  65% { transform: translate(2px, -2px); }
  67.5% { transform: translate(-2px, 2px); }
  70% { transform: translate(2px, -2px); }
  72.5% { transform: translate(0, 0); }
  75%,100% { transform: translate(0, 0); } /* Rest period */
`;
const BottomNav = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box
      display={{ md: "none" }}
      position="fixed"
      bottom="0"
      left="0"
      width="100%"
      bg="#28211d"
      color="#F5C7A9"
      py={1}
      zIndex="1000"
      height="70px"
    >
      <HStack justify="space-around">
        <VStack spacing={1}>
          <Link
            href="tel:+919256491206"
            aria-label="Call Qualiteeth Dental Care on +91 92564 91206"
            _hover={{ color: "#c49d84" }}
            color="#F5C7A9"
            css={{
              animation: `${vibrateWithDelay} 6s ease-in-out infinite`,
            }}
          >
            <Icon as={FaPhoneAlt} marginTop={{ base: 2 }} boxSize={7} />
          </Link>
          <Text fontSize="sm">Phone</Text>
        </VStack>

        <VStack spacing={1} align="center" marginLeft={5}>
          <IconButton
            name="Book Online"
            aria-label="Book Online"
            icon={<FaCalendarAlt />}
            variant="ghost"
            color="#F5C7A9"
            fontSize="3xl"
            onClick={onOpen}
          />
          <Text fontSize="sm">Book Online</Text>
          <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="xl"
            blockScrollOnMount={true}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalCloseButton />
              <ModalBody>
                <iframe
                  title="Book an appointment at Qualiteeth Dental Care"
                  src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ0HH7UcCwpUcb-NlDA38ZGn_NmQqHUJ9llAjBKixKAX-8BT0MCXFwBnZaMcnlb3-6fw9BMPDcs2?gv=true"
                  style={{ border: "0", width: "100%", height: "600px" }}
                  frameBorder="0"
                ></iframe>
              </ModalBody>
            </ModalContent>
          </Modal>
        </VStack>

        <VStack spacing={1}>
          <Link
            href="https://www.google.com/maps/place/Qualiteeth+Dental+Care/@26.9018108,75.7366896,17z/data=!3m1!4b1!4m6!3m5!1s0x396db52aa8fff4cf:0xfd055fea55b4585d!8m2!3d26.901806!4d75.7392645!16s%2Fg%2F11l5vzlvgg?entry=ttu&g_ep=EgoyMDI1MDIxMS4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener"
            aria-label="Get directions to Qualiteeth Dental Care on Google Maps"
            _hover={{ color: "#c49d84" }}
            color="#F5C7A9"
          >
            <Icon as={FaMapMarkerAlt} marginTop={{ base: 2 }} boxSize={7} />
          </Link>
          <Text fontSize="sm">Location</Text>
        </VStack>
      </HStack>
    </Box>
  );
};

export default BottomNav;
